import states from "./states"
import {
  UPDATE_CONTACTS_STATE,
  CONTACT_CREATED,
  CONTACT_DELETED,
  CONTACTS_STATUS,
  CONTACTS_UPDATE,
} from "./actiontypes"

const contacts_details = (state = states.contacts_details, action) => {
  switch (action.type) {
    case UPDATE_CONTACTS_STATE:
      return {
        ...state,
        ...action.payload,
      }

    case CONTACT_CREATED:
      return {
        ...state,
        contacts: [action.payload, ...state.contacts],
      }

    case CONTACTS_STATUS: {
      const pollingIds = state.pollingIds || []

      const updates = Array.isArray(action.payload)
        ? action.payload
        : [action.payload]

      let newPollingIds = [...pollingIds]

      updates.forEach(item => {
        if (item?.status !== "Success" && item?.status !== "Failed") {
          if (!newPollingIds.includes(item?.id)) {
            newPollingIds.push(item?.id)
          }
        } else {
          newPollingIds = newPollingIds.filter(id => id !== item?.id)
        }
      })

      return {
        ...state,
        pollingIds: newPollingIds,
      }
    }

    case CONTACTS_UPDATE:
      const updatedContacts = action.payload

      return {
        ...state,
        contacts: state.contacts.map(existingContact => {
          const updatedContact = updatedContacts.find(
            contact => contact.id === existingContact.id
          )
          return updatedContact
            ? { ...existingContact, ...updatedContact }
            : existingContact
        }),
      }

    case CONTACT_DELETED: {
      let index = -1
      index = state.contacts.findIndex(
        contact => contact.id === action.payload
      )
      if (index !== -1)
        return {
          ...state,
          contacts: [
            ...state.contacts.slice(0, index),
            ...state.contacts.slice(index + 1),
          ],
        }
      return state
    }

    default:
      return state
  }
}

export default contacts_details
